/* lua.js generated code 0.3.0 */

require("clover/ui/UIItemBuilder")
require("clover/panel/component/common/uiGroupButtonLayout/UIGLabelButton")
require("clover/panel/component/common/uiGroupButtonLayout/UIGIconNumLabelButton")
require("clover/panel/component/common/uiButtonAnims/PushBounceIdleBubbleAnim")
require("clover/panel/component/common/uiButtonAnims/PushBounceIdleShakeAnim")
require("clover/panel/component/bagpanel/PropBagAnimation")
require("clover/animation/ui/HomeSceneAnimation")
let { needHideRewardNum } = require("./MarkViewUtil")

let SnsProxy = require("clover/sns/SnsProxy")
var ButtonPushBounceAnim = require("clover/panel/component/common/uiButtonAnims/PushBounceAnim")
var ButtonPushBounceIdleBubbleAnim = require("clover/panel/component/common/uiButtonAnims/PushBounceIdleBubbleAnim")
var MarkRewardPanel = require("clover/panel/MarkRewardPanel")
var MarkRewardPanelRandom = require("clover/panel/MarkRewardPanelRandom")
var [MarkItem, MarkItemEvent] = unpack(require("clover/panel/component/markpanel/MarkItem"))
var MarkedItem = require("clover/panel/component/markpanel/MarkedItem")
var RemarkItem = require("clover/panel/component/markpanel/RemarkItem")
var UISubscribeMsg = require("clover/ui/UISubscribeMessage")
require("clover/ui/TiledSpriteBuilder")

var NewMarkPanel = xClass("NewMarkPanel", BasePanel, function () {
    // WARN: maybe multi result
    return cc.CSLoader.createNode("cocos/mark_panel_3_panel.csb")
})
var markDay_total = 7           //  签到周期
var NewMarkPanelEvent = {
    Close: "NEWMARKPANELEVENT.CLOSE",
    Mark: "NEWMARKPANELEVENT.MARK",
    AdMark: "NEWMARKPANELEVENT.ADMARK",
    ClickRemark: "NEWMARKPANELEVENT.CLICKREMARK",
    Remark: "NEWMARKPANELEVENT.REMARK",
    RewardPanelClose: "NEWMARKPANELEVENT.REWARDPANELCLOSE",
    GetReward: "NEWMARKPANELEVENT.GETREWARD"
}
let NewMarkPanelPreloadConfig = [];

NewMarkPanel.asyncCreate = function (info, newInfo, _callback, fail) {
    function callback() {
        //  玩家有可能通过其他功能类分享进入的游戏，导致进入游戏后进入关卡场景（例如攻略）后依旧会弹出签到面板
        //  所以异步加载的签到面板在弹出来之间需要检查是否还位于HomeScene
        if (cc.director._runningScene.name === "HomeScene") {
            //  预加载广告
            var snsProxy = SnsProxy.getInstance()
            if (snsProxy.allowAd()) {
                snsProxy.prepareAd("Remark")
                .then(()=>{
                    NewMarkPanel.prepareAd = true
                    var panel = NewMarkPanel.create(info, newInfo)
                    _callback(panel)
                })
                .catch(err=> {
                    NewMarkPanel.prepareAd = false
                    var panel = NewMarkPanel.create(info, newInfo)
                    _callback(panel)
                })
            } else {
                NewMarkPanel.prepareAd = false
                var panel = NewMarkPanel.create(info, newInfo)
                _callback(panel)
            }
        } else {
            let preload_list = buildResList(NewMarkPanelPreloadConfig)
            unloadResList(preload_list)
            fail && fail()
        }
    }
    function onFail() {
        Toast.make(getText("error.tip.timeout"), 1, () => {
            fail && fail()
        })
    }
    NewMarkPanelPreloadConfig = ["packed/NewMarkPanel.pack"]
    if (TTUtil.isOpenSmallPay()){
        NewMarkPanelPreloadConfig.push("packed/ttGameRevivePanel.pack")
    }
    preloadWithLoading(NewMarkPanelPreloadConfig, callback, onFail)
}
NewMarkPanel.prototype.cleanup = function () {
    BasePanel.prototype.cleanup.call(this)
    let preload_list = buildResList(NewMarkPanelPreloadConfig)
    unloadResList(preload_list)
    if (this.subMsg){
        this.subMsg.cleanUp()
    }
}
NewMarkPanel.prototype.ctor = function (info, newInfo) {
    var self = this
    self.config = clone(info)
    self.newConfig = clone(newInfo)
    BasePanel.prototype.ctor.call(self)
    self.todayAdReward = 0                                              //  今日签到版所属签到列表的编号
    self.todayMarkRewardAnim = true                                     //  今日签到奖励动画播放状态，用于判定补签时是否播放七日连签奖励动画
    self.buildUI(info)
    var scaleY = display.height / GamePlayConfig_Design_Height
    var scaleX = display.width / GamePlayConfig_Design_Width
    var scale = Math.min(scaleX, scaleY)
    self._scale = scale
    self.setScale(scale)
}
// 是否最后一天签到 只差最后一次补签
NewMarkPanel.prototype.isLastRemark = function (info) {
    // info.remainDayNum = 1
    if (info.remainDayNum != 1){
        return false
    }
    let needRemarkNum = 0
    for (var i = 0; i < markDay_total; i++) {
        if (i + info.remainDayNum >= 7) {
            cc.log("MarkLogic needRemark flase")
            if (i + info.remainDayNum == 7) {
                cc.log("MarkLogic needRemark isToday")
            }
        } else {
            cc.log("MarkLogic needRemark true")
            if (info.markList[(i+1)] == MarkStatus.UN_MARK){
                needRemarkNum ++ 
            }
        }
    }
    cc.log("MarkLogic needRemarkNum ",needRemarkNum)
    cc.log("MarkLogic needRemarkNum == 1 ",needRemarkNum == 1)

    return needRemarkNum == 1
}

NewMarkPanel.prototype.buildUI = function (info) {
    var self = this

    //  背景板平铺
    var frame_middle = self.getChildByName("dec2").getChildByName("middle")
    if (_G.__use_low_effect) {
        //  因为低清模式下，素材的精度会丢失，再通过平铺放大后会非常明显，所以低清模式下需要多平铺误差缺失的一部分
        var middle = TiledSpriteBuilder.createTiledBackgrnd("mark_panel_3/dec_title2.png", cc.p(11, 0.99))
        frame_middle.y -= 2.3
    } else {
        var middle = TiledSpriteBuilder.createTiledBackgrnd("mark_panel_3/dec_title2.png", cc.p(11, 1))
        frame_middle.x += 1
        self.getChildByName("dec2").getChildByName("left").x += 2
    }
    self.getChildByName("dec2").addChild(middle)
    middle.setPosition(cc.p(frame_middle.getPosition()))
    middle.setAnchorPoint(frame_middle.getAnchorPoint())
    frame_middle.removeFromParent()

    //  标题
    var title = self.getChildByName("title")
    title.setAnchorPoint(0.5, 1)
    title.setString(getText("mark.panel.title"))
    title.setPositionX(self.getContentSize().width / 2)

    //  连签天数Tip
    self.markTip = self.getChildByName("txt_mark")
    self.markTip.setFontWeight("bold")
    self.markTip.setString(getText("mark.tip.bottom", {n: 0}))

    //  连签内容Tip
    self.tip = self.getChildByName("txt_tip")
    self.tip.setString(getText("mark.tip.top"))
    self.tip.getVirtualRenderer().setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER)
    self.tip.getVirtualRenderer().setVerticalAlignment(cc.VERTICAL_TEXT_ALIGNMENT_CENTER)

    //  关闭按钮
    var close = self.getChildByName("btn_close")
    UIButton.create(close)
    close.on(UIButtonEvent.Click, function () {
        self.trySubscribeMsg()
        self.dispatchEvent({
            name: NewMarkPanelEvent.Close
        })
    })

    //  签到面板
    var day = new Date(info.cycleStartTime)
    var myday = day.getDay() || 7
    var todayAdReward = -1
    var markedDay = self.getMarkedDay(info.markList);
    self.markNode = []
    var adRewardDay = UserMark.getInstance().getDayPreContinuous()
    cc.log("MarkLogic remainDayNum",info.remainDayNum)
    cc.log("MarkLogic info",info)
    let isLastRemark = self.isLastRemark(info)
    for (var i = 0; i < markDay_total; i++) {
        var markInfo = {}
        if (i + info.remainDayNum >= 7) {
            markInfo.needRemark = false
            if (i + info.remainDayNum == 7) {
                markInfo.isToday = true
                todayAdReward = i
            }
        } else {
            markInfo.needRemark = true
        }
        markInfo.markedDay = markedDay
        markInfo.fullMarkReward = info.markRef.mark_reward_full;
        var today = (myday - 1 + i) % markDay_total + 1
        var oldNode = self.getChildByName("day" + (i+1))
        markInfo.day = i+1
        if (info.markList[(i+1)] == MarkStatus.UN_MARK) {
            //  标记今日签到奖励动画播放状态
            if (todayAdReward == i) {
                self.todayMarkRewardAnim = false
            }
            markInfo.mark_reward = info.markRef.mark_reward[today]
            markInfo.mark_reward_ad = info.markRef.mark_reward_ad[adRewardDay]
            markInfo.remarkPrice = info.price
            markInfo.canVideoRemark = self.canVideoRemark(info.markRef.remark_ad_daily_limit, info.videoTimes, isLastRemark)
            var markNode = self.createMarkNode(markInfo)
            markNode.setPosition(oldNode.getPosition())
            markNode.on(MarkItemEvent.ClickRemark, function (evt) {
                self.dispatchEvent({
                    name: NewMarkPanelEvent.Remark,
                    day: evt.day,
                    isVideoRemark: evt.isVideoRemark
                })
            })
        } else {
            var markNode = MarkedItem.create(markInfo)
            markNode.setPosition(oldNode.getPosition())
        }
        cc.eventManager.removeListener(oldNode.listenner)
        oldNode.removeFromParent(true)
        self.addChild(markNode)
        self.markNode[i] = markNode
    }
    self.todayAdReward = todayAdReward

    //  连签奖励
    self.reward_full = self.getChildByName("day_all")
    var reward_full_txt = self.reward_full.getChildByName("txt")
    reward_full_txt.setFontWeight("bold")
    reward_full_txt.getVirtualRenderer().setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER)
    reward_full_txt.getVirtualRenderer().setVerticalAlignment(cc.VERTICAL_TEXT_ALIGNMENT_CENTER)
    reward_full_txt.y -= 2
    //  设置连签状态
    self.fullMark = self.reward_full.getChildByName("signet_purple1")
    self.fullMark.setRotation(6)
    self.fullMark.y += 6
    self.fullMark.x -= 3
    self.fullMark.setScale(1.1)
    self.isFullMark = true
    //  检查签到状态
    for (var i = 1; i <= $len(info.markList); i++) {
        if (info.markList[i] === MarkStatus.UN_MARK) {
            self.isFullMark = false
        }
    }
    if (self.isFullMark) {
        //  已签到七天
        self.reward_full.getChildByName("frame").setVisible(false)
        self.reward_full.getChildByName("reward_prop_2").setVisible(false)
        self.reward_full.getChildByName("reward_prop_1").setVisible(false)
        //  已签到动画
        self.fullMarkAnim = cc.CSLoader.createTimeline("cocos/mark_panel_3_signet_purple1.csb");
        self.fullMark.runAction(self.fullMarkAnim)
        self.fullMarkAnim.gotoFrameAndPlay(0, false);
    } else {
        //  尚未签满七天
        self.reward_full.getChildByName("frame_marked").setVisible(false)
        self.reward_full.getChildByName("signet_purple1").setVisible(false)
        self.reward_full_reward = []
        if (info.markRef.mark_reward_full.length == 0) {
            //  没有奖励，肯定是配置错了，那也什么都不显示
            for (var i = 1; i <= 2; i++) {
                reward_full.getChildByName("reward_prop_" + i).setVisible(false)
            }
        } else if (info.markRef.mark_reward_full.length == 1) {
            //  单个奖励，目前来说是正常配置
            var reward = info.markRef.mark_reward_full[0].split(':')
            reward_full.getChildByName("reward_prop_2").setVisible(false)
            self.reward_full_prop = {}
            self.reward_full_prop[0] = reward_full.getChildByName("reward_prop_1")
            self.reward_full_prop[0].x += 20
            //  奖励图标
            var num = self.reward_full_prop[0].getChildByName("num")
            var propMeta = MetaManager.getInstance().getPropMeta(reward[0])
            var icon = self.reward_full_prop[0].getChildByName("icon")
            if (propMeta && propMeta.expireTime !== 0) {
                propIcon = UIItemBuilder.createPropIcon(reward[0], (Localhost.time() + propMeta.expireTime))
                //propIcon.setPosition(icon.getPostion)
                propIcon.x = icon.x
                propIcon.y = icon.y
                propIcon.setAnchorPoint(icon.getAnchorPoint())
                propIcon.setName(icon.getName())
                propIcon.setScale(icon.getScale())
                icon.removeFromParent(true)
                self.reward_full_prop[0].addChild(propIcon)
                num.setLocalZOrder(propIcon.getLocalZOrder() + 1)
            } else {
                self.reward_full_prop[0].getChildByName("icon").setSpriteFrame(UIItemBuilder.createPropIcon(reward[0]).getSpriteFrame())
            }
            if (needHideRewardNum(reward[0])) {
                //  如果是10分钟无限精力瓶则不显示数量
                num.setVisible(false)
            } else {
                num.setString(reward[1])
                num.setNextFontPositionXOffset(-4)
                //  如果奖励是货币，则需要调整一下数量位置
                if (NewMarkPanel.rewardIsCurrency(reward[0])) {
                    num.x -= 20
                    num.y -= 5
                } else {
                    num.x += 4
                    num.y -= 5
                }
            }
            self.reward_full_reward[0] = {id:reward[0], num:reward[1], pos:self.reward_full_prop[0].getPosition()}
            //  奖励特效
            var action = cc.CSLoader.createTimeline("cocos/mark_panel_3_smallstar.csb");
            self.reward_full_prop[0].getChildByName("effect").runAction(action)
            action.gotoFrameAndPlay(0, true);
        } else {
            //  多个奖励，因为UI目前的大小，最多也就只能显示两个
            self.reward_full_prop = []
            for (var i = 0; i < 2; i++) {
                self.reward_full_prop[i] = self.reward_full.getChildByName("reward_prop_" + (i+1))
                var reward = info.markRef.mark_reward_full[i].split(':')
                //  奖励图标
                var num = self.reward_full_prop[i].getChildByName("num")
                var propMeta = MetaManager.getInstance().getPropMeta(reward[0])
                var icon = self.reward_full_prop[i].getChildByName("icon")
                if (propMeta && propMeta.expireTime !== 0) {
                    propIcon = UIItemBuilder.createPropIcon(reward[0], (Localhost.time() + propMeta.expireTime))
                    //propIcon.setPosition(icon.getPostion)
                    propIcon.x = icon.x
                    propIcon.y = icon.y
                    propIcon.setAnchorPoint(icon.getAnchorPoint())
                    propIcon.setName(icon.getName())
                    propIcon.setScale(icon.getScale())
                    icon.removeFromParent(true)
                    self.reward_full_prop[i].addChild(propIcon)
                    num.setLocalZOrder(propIcon.getLocalZOrder() + 1)
                } else {
                    self.reward_full_prop[i].getChildByName("icon").setSpriteFrame(UIItemBuilder.createPropIcon(reward[0]).getSpriteFrame())
                }
                if (needHideRewardNum(reward[0])) {
                    //  如果是10分钟无限精力瓶则不显示数量
                    num.setVisible(false)
                } else {
                    num.setString(reward[1])
                    num.setNextFontPositionXOffset(-4)
                    //  如果奖励是货币，则需要调整一下数量位置
                    if (NewMarkPanel.rewardIsCurrency(reward[0])) {
                        num.x -= 20
                        num.y -= 5
                    } else {
                        num.x += 4
                        num.y -= 5
                    }
                }
                self.reward_full_reward[i] = {id:reward[0], num:reward[1], pos:self.reward_full_prop[i].getPosition()}
                //  奖励特效
                var action = cc.CSLoader.createTimeline("cocos/mark_panel_3_smallstar.csb");
                self.reward_full_prop[i].getChildByName("effect").runAction(action)
                action.gotoFrameAndPlay(0, true);
            }
        }
    }

    //  如果现在不能签到则只显示继续游戏按钮，否则显示签到按钮
    self.btnContinue = self.getChildByName("btn_continue")
    self.btnContinue.getChildByName("label").x += 3
    //  美术flash出的看广告按钮的锚点异常，会导致呼吸动画看起来很别扭，所以这次直接做了一个调整
    self.btnContinue.setAnchorPoint(0.5, 0)
    var size = self.btnContinue.getContentSize()
    self.btnContinue.x += size.width / 2
    //  继续按钮
    self.btnContinue = UIGroupButton.create(self.btnContinue, true)
    self.btnContinue.on(UIButtonEvent.Click, function () {
        self.trySubscribeMsg()
        self.dispatchEvent({
            name: NewMarkPanelEvent.Close
        })
    })
    self.btnContinue.getChildByName("label").setString(getText("mark.button3"))
    ButtonPushBounceAnim.create(self.btnContinue)
    ButtonPushBounceIdleBubbleAnim.create(self.btnContinue)

    self.btnReward = self.getChildByName("btn_reward")
    self.btnReward.setAnchorPoint(0.5, 0)
    var size = self.btnReward.getContentSize()
    self.btnReward.x += size.width / 2
    self.btnAd = self.getChildByName("btn_ad")
    self.adRewardCloud = self.getChildByName("bubblebox")
    self.adRewardCloud.setAnchorPoint(0.5, 0)
    var size = self.adRewardCloud.getContentSize()
    self.adRewardCloud.x += size.width / 2
    if (info.canMark) {
        self.btnContinue.setVisible(false)
        //  普通签到按钮
        self.btnReward = UIGroupButton.create(self.btnReward, true)
        self.btnReward.on(UIButtonEvent.Click, function () {
            self
            self.dispatchEvent({
                name: NewMarkPanelEvent.Mark
            })
        })
        self.btnReward.getChildByName("txt").setString(getText("mark.button1"))
        ButtonPushBounceAnim.create(self.btnReward)
        ButtonPushBounceIdleBubbleAnim.create(self.btnReward)
        self.btnReward.getChildByName("txt").x += 20
        //  看广告签到按钮
        //  美术flash出的看广告按钮的锚点异常，会导致呼吸动画看起来很别扭，所以这次直接做了一个调整
        self.btnAd.setAnchorPoint(0.5, 0)
        DYAdUtil.modifyIconAttribute(self.btnAd.getChildByName("icon"),self.btnAd,{
            pos: cc.p(15,-27)
        });
        if (DYAdUtil.isOpen()){
            // "disabled"click"normal"
            DYAdUtil.modifyBtnSize(self.btnAd,cc.size(280,120))
            DYAdUtil.modifyBtnSize(self.btnReward,cc.size(280,120))

            self.btnAd.x = 312
            self.btnReward.x = 224
            self.btnReward.getChildByName("txt").x = -46
        }


        var size = self.btnAd.getContentSize()
        self.btnAd.x += size.width / 2
        self.btnAd.y += 2
        self.btnAd = UIGroupButton.create(self.btnAd, true)
        self.btnAd.on(UIButtonEvent.Click, function () {
            self.dispatchEvent({
                name: NewMarkPanelEvent.AdMark,
                "ttUseDiamond": self.ttUseDiamond,
                ad_session: self.ad_session
            })
        })
        self.btnAd.getChildByName("label").x += 20
        self.btnAd.getChildByName("label").setString(getText("mark.button2"))
        ButtonPushBounceAnim.create(self.btnAd)
        ButtonPushBounceIdleBubbleAnim.create(self.btnAd)
        //  看广告签到奖励
        if (adRewardDay >= 0) {
            self.adRewardCloud.x += 18
            var todayAdRewardLength = self.config.markRef.mark_reward_ad[adRewardDay].length
            self.adRewardNode = []
            for (var i = 0; i < (2 < todayAdRewardLength ? 2 : todayAdRewardLength); i++) {
                var reward = self.adRewardCloud.getChildByName("icon" + (i+1))
                var icon = reward.getChildByName("icon")
                reward.getChildByName("icon").setScale(0.75)
                reward.getChildByName("icon").x += 5
                var num = reward.getChildByName("num")
                reward.num = self.config.markRef.mark_reward_ad[adRewardDay][i].num
                reward.getChildByName("num").setString(self.config.markRef.mark_reward_ad[adRewardDay][i].num)
                reward.getChildByName("num").setNextFontPositionXOffset(-4)
                reward.getChildByName("num").setScale(1)
                //  奖励图标
                reward.propId = self.config.markRef.mark_reward_ad[adRewardDay][i].id
                var propMeta = MetaManager.getInstance().getPropMeta(reward.propId)
                
                if (propMeta && propMeta.expireTime !== 0) {
                    propIcon = UIItemBuilder.createPropIcon(self.config.markRef.mark_reward_ad[adRewardDay][i].id, (Localhost.time() + propMeta.expireTime))
                } else {
                    propIcon = UIItemBuilder.createPropIcon(self.config.markRef.mark_reward_ad[adRewardDay][i].id)
                }
                propIcon.x = icon.x
                propIcon.y = icon.y
                propIcon.setAnchorPoint(icon.getAnchorPoint())
                propIcon.setName(icon.getName())
                propIcon.setScale(icon.getScale())
                icon.removeFromParent(true)
                reward.addChild(propIcon)
                num.setLocalZOrder(propIcon.getLocalZOrder() + 1)
                 
                if (NewMarkPanel.rewardIsCurrency(self.config.markRef.mark_reward_ad[adRewardDay][i].id)) {
                    reward.getChildByName("num").x = 40
                    reward.getChildByName("num").y = -30.15
                } else {
                    reward.getChildByName("num").x = 48
                    reward.getChildByName("num").y = -35.05
                }
                self.adRewardNode[i] = reward
            }
        } else {
            self.adRewardCloud.setVisible(false)
        }
        let [isOpen,limit] = AdTagManager.getInstance().getAdStrategyByAdType(AdTagManager.AdType.ad_mark)
        if (!isOpen){
            console.log("[AdTag] 签到广告限制 isOpen",isOpen)
            
            self.adRewardCloud.setVisible(false)
            self.btnAd.setVisible(false)
            self.btnReward.x = display.width/2 //display.width/2
            self.btnReward.x += 35
            self.btnReward.getChildByName("txt").setString(getText("签到领奖"))
        }
    } else {
        self.adRewardCloud.setVisible(false)
        self.btnReward.setVisible(false)
        self.btnAd.setVisible(false)
        self.btnContinue.setVisible(false)
    }
    self.initSubscribeMessage(info.canMark)
    if (self.btnAd.isVisible()){
        let ad_session = `${UserManager.getInstance().uid}_${Localhost.timeInSec()}`
        DCAssist.dc4User101("mark","mark_ad_button_show",{session:ad_session} )

        self.ad_session = ad_session
        self.ttUseDiamond = UserManager.getInstance().getTTSmallAmountUseDiamond()
        self.tt_buuble = TTUtil.addSmallPayBubble(self.btnAd,(ttUseDiamond)=>{
            self.ttUseDiamond = ttUseDiamond
        },{
            type: "mark",
            session:ad_session
        },{
           fixPos: cc.p(0,-25) 
        })
    }
    //  刷新连签日期
    self.updateSignDay()
}

NewMarkPanel.prototype.rewardItemAnims = function (items, finishCallback, lockTable) {
    var self = this
    var flyItemOps = table()
    var counter = 0
    function onAnimFinish() {
        counter = counter + 1
        if (counter >= $len(items)) {
            if (finishCallback) {
                finishCallback()
            }
        }
    }
    for (let i = 1, v = items[1]; v; i++, v = items[i]) {
        var parent = v.icon.getParent()
        var pos = parent.convertToWorldSpace(cc.p(v.icon.getPosition()))
        if (v.itemId === GamePropIds.kCoin) {
            self.playCoinAnimation(v.icon, v.num, onAnimFinish)
        } else {
            table.insert(flyItemOps, {
                itemId: v.itemId,
                num: v.num,
                pos: pos
            })
        }
    }
    if (type(lockTable) === "table") {
        var HomeScene = require("clover/scene/HomeScene")
        var infoBanner = HomeScene.getInstance().infoBanner
        infoBanner.releaseCoin(lockTable.coin || 0)
        infoBanner.releaseCash(lockTable.cash || 0)
    }
    if ($len(flyItemOps) > 0) {
        PropBagAnimation.addItemsToBag(flyItemOps, onAnimFinish, 0.15)
    }
}
NewMarkPanel.prototype.onEnter = function () {
    var self = this
    BasePanel.prototype.onEnter.call(self)
    // require("clover/scene/HomeScene").getInstance().highlightInfoBanner(true)
}
NewMarkPanel.prototype.onExit = function () {
    var self = this
    BasePanel.prototype.onExit.call(self)
    // require("clover/scene/HomeScene").getInstance().returnInfoBanner()
}
NewMarkPanel.prototype.popup = function (dark, canTouchBehind, callback, lockTable) {
    var self = this
    // //self.mark.anim.removeAnim()
    // //self.remark.anim.removeAnim()
    // if (self.newConfig) {
    //     self.mark.setScale(0)
    //     self.remark.setScale(0)
    // }
    BasePanel.prototype.popup.call(self, dark, canTouchBehind, function () {
        if (callback) {
            callback(self.config.canMark)
        }
    })
    DCAssist.dc4User101("mark", "mark_show");
}

/**
 * 检查奖励是否为货币
 * @param rewardId  奖励Id
 */
NewMarkPanel.rewardIsCurrency = function (rewardId) {
    if (rewardId == GamePropIds.kCoin || rewardId == GamePropIds.kCash) {
        return true
    } else {
        return false
    }
}

/**
 * 更新连签天数信息
 */
NewMarkPanel.prototype.updateSignDay = function () {
    var self = this;

    var markList = clone(self.config.markList)
    if (!self.todayMarkRewardAnim) {
        markList[self.todayAdReward + 1] = MarkStatus.UN_MARK
    }
    //  检查签到信息和UI
    if (markList && self.markTip) {
        //  计算当前签到周期最大连签天数
        let max = 0;
        let now = 0;
        for (var i = 0; i < markList.length; i++) {
            if (markList[i] === MarkStatus.MARKED) {
                now = now + 1;
            } else {
                max = now > max ? now : max;
                now = 0
            }
        }
        max = now > max ? now : max;
        self.markTip.setString(getText("mark.tip.bottom", {n: max}));
    }
}
/**
 * 刷新面板
 */
NewMarkPanel.prototype.refresh = function (info, animType, finishCallback, lockTable) {
    var self = this
    if (type(animType) === "number" && animType !== 0) {
        self.refreshWithAnim(info, animType, finishCallback, lockTable)
    } else {
        //self.refreshWithoutAnim(info)
        if (finishCallback) {
            finishCallback()
        }
    }
    self.config = info
}

/**
 *  播放获取奖励动画
 */
NewMarkPanel.prototype.playGetRewardAnim = function (callback) {
    var self = this

    if (self.todayAdReward || self.todayAdReward == 0) {
        var prop = self.markNode[self.todayAdReward].reward_single
        var flyItemOps = table()
        var pos = self.markNode[self.todayAdReward].convertToWorldSpace(cc.p(prop.getPosition()))
        var reward =  self.markNode[self.todayAdReward].config.mark_reward[0].split(':')
        table.insert(flyItemOps, {
            itemId: tonumber(reward[0]),
            num: tonumber(reward[1]),
            pos: pos,
            scale: 1
        })
        HomeSceneAnimation.playGetPropAnimation(flyItemOps, callback, 0.3)
        //  七连签奖励
        if (UserMark.getInstance().getDayPreContinuous() == 7 && self.todayMarkRewardAnim) {
            var flyItemOps = table()
            for (i = 0; i < self.reward_full_reward.length; i++) {
                var pos = self.reward_full.convertToWorldSpace(cc.p(self.reward_full_reward[i].pos))
                table.insert(flyItemOps, {
                    itemId: tonumber(self.reward_full_reward[i].id),
                    num: tonumber(self.reward_full_reward[i].num),
                    pos: pos,
                    scale: 1
                })
                HomeSceneAnimation.playGetPropAnimation(flyItemOps, null, 0.3)
            }
        }
    } else {
        if (callback) {
            callback()
        }
    }
}

/**
 *  播放获取补签奖励动画
 */
NewMarkPanel.prototype.playGetRemarkRewardAnim = function (targetDay, callback, isSevenReward = false) {
    var self = this

    targetDay -= 1
    if ((targetDay || targetDay == 0) || (self.config.markList[targetDay+1] === 0)) {
        //  普通奖励
        var prop = self.markNode[targetDay].reward_single
        var flyItemOps = table()
        var pos = self.markNode[targetDay].convertToWorldSpace(cc.p(prop.getPosition()))
        var reward =  self.markNode[targetDay].config.mark_reward[0].split(':')
        table.insert(flyItemOps, {
            itemId: tonumber(reward[0]),
            num: tonumber(reward[1]),
            pos: pos,
            scale: 1
        })
        showGlobalMask()
        HomeSceneAnimation.playGetPropAnimation(flyItemOps, ()=> {
            hideGlobalMask();
            callback && callback();
        }, 0.3)
        //  七连签奖励
        if (isSevenReward && self.todayMarkRewardAnim) {
            var flyItemOps = table()
            for (i = 0; i < self.reward_full_reward.length; i++) {
                var pos = self.reward_full.convertToWorldSpace(cc.p(self.reward_full_reward[i].pos))
                table.insert(flyItemOps, {
                    itemId: tonumber(self.reward_full_reward[i].id),
                    num: tonumber(self.reward_full_reward[i].num),
                    pos: pos,
                    scale: 1
                })
                HomeSceneAnimation.playGetPropAnimation(flyItemOps, null, 0.3)
            }
        }
    } else {
        if (callback) {
            callback()
        }
    }
}

NewMarkPanel.prototype.onNormalReward = function (info, callback) {
    var self = this

    self.btnAd.setVisible(false)
    if (self.tt_buuble)self.tt_buuble.setVisible(false)
    self.btnReward.setVisible(false)
    self.btnContinue.setVisible(true)
    self.btnContinue.setScale(1)
    self.btnContinue.x = 320
    self.btnContinue.y = -910
    self.adRewardCloud.setVisible(false)
}
/**
 * 播放获取看广告奖励动画
 */
NewMarkPanel.prototype.playAdRewardAnim = function (info, callback) {
    var self = this

    //  关闭按钮
    self.btnAd.setVisible(false)
    if (self.tt_buuble)self.tt_buuble.setVisible(false)
    self.btnReward.setVisible(false)
    self.btnContinue.setVisible(true)
    self.btnContinue.setScale(1)
    self.btnContinue.x = 320
    self.btnContinue.y = -910
    self.adRewardCloud.setVisible(false)

    var playMarkAnim = function () {
        //  播放普通签到奖励动画
        self.refreshWithAnim(info, callback, false)
    }

    //  飞道具动画
    if (self.adRewardNode) {
        var flyItemOps = table()
        for (var i = 0; i < self.adRewardNode.length; i++) {
            var prop = self.adRewardNode[i]
            var pos = self.adRewardCloud.convertToWorldSpace(cc.p(prop.getPosition()))
            table.insert(flyItemOps, {
                itemId: tonumber(prop.propId),
                num: tonumber(prop.num),
                pos: pos,
                scale: 1
            })
            if (i == 0) {
                HomeSceneAnimation.playGetPropAnimation(flyItemOps, playMarkAnim, 0.3)
            } else {
                HomeSceneAnimation.playGetPropAnimation(flyItemOps, null, 0.3)
            }
        }   
    } else {
        if (playMarkAnim) {
            playMarkAnim()
        }
    }
}

/** 
 * 播放签到动画
 * @param info              签到完毕后的信息
 * @param finishCallback    动画播放结束回调
 * @param showBtn         
*/
NewMarkPanel.prototype.refreshWithAnim = function (info, finishCallback, showBtn = true) {
    var self = this

    var refreshPanel = function () {
        var oldInfo = self.config
        var day = new Date(info.cycleStartTime)
        var myday = day.getDay() || 7
        var markedDay = self.getMarkedDay(info.markList);
        self.todayMarkRewardAnim = true
        let isLastRemark = self.isLastRemark(info)
        for (var i = 0; i < markDay_total; i++) {
            var markInfo = {}
            if (i + info.remainDayNum >= 7) {
                markInfo.needRemark = false
                if (i + info.remainDayNum == 7) {
                    markInfo.isToday = true
                    self.todayAdReward = i
                } else {
                    continue
                }
            } else {
                continue
            }
            markInfo.markedDay = markedDay;
            markInfo.fullMarkReward = info.markRef.mark_reward_full;
            var today = (myday - 1 + i) % markDay_total + 1
            var oldNode = self.markNode[i]
            markInfo.day = i+1
            if (info.markList[(i+1)] == MarkStatus.UN_MARK) {
                //  标记今日签到奖励动画播放状态
                if (self.todayAdReward == i) {
                    self.todayMarkRewardAnim = false
                }
                markInfo.mark_reward = info.markRef.mark_reward[today]
                markInfo.mark_reward_ad = info.markRef.mark_reward_ad[today]
                
                markInfo.remarkPrice = info.price
                markInfo.canVideoRemark = self.canVideoRemark(info.markRef.remark_ad_daily_limit, info.videoTimes, isLastRemark)
                var markNode = self.createMarkNode(markInfo)
                markNode.setPosition(oldNode.getPosition())
                markNode.on(MarkItemEvent.ClickRemark, function (evt) {
                    self.dispatchEvent({
                        name: NewMarkPanelEvent.Remark,
                        day: evt.day,
                        isVideoRemark: evt.isVideoRemark
                    })
                })
                cc.eventManager.removeListener(oldNode.listenner)
                self.markNode[i] = markNode
            } else {
                var markNode = MarkedItem.create(markInfo)
                markNode.setPosition(oldNode.getPosition())
            }
            self.addChild(markNode)
            cc.eventManager.removeListener(oldNode.listenner)
            oldNode.removeFromParent(true)
            self.markNode[i] = markNode
        }

        //  设置连签状态
        self.refreshFullMarkWithAnim(info)
        
        self.runAction(cc.sequence(cc.delayTime(0.5), cc.callFunc(function () {
            if (finishCallback) {
                finishCallback()
            }
        })))
        
        //  刷新签到配置
        self.updateSignDay()
    }

    self.playGetRewardAnim(refreshPanel)
}

/**
 * 刷新连签面板
 * @param info
 * @return  bool    是否达成七天连签
 */
NewMarkPanel.prototype.refreshFullMarkWithAnim = function (info) {
    var self = this

    if (!self.reward_full || !info) {
        return
    }

    var isFullMark = true
    //  检查签到状态
    for (var i = 1; i <= $len(info.markList); i++) {
        if (info.markList[i] === MarkStatus.UN_MARK) {
            isFullMark = false
        }
    }
    //  设置连签状态
    if (isFullMark && !self.isFullMark && self.todayMarkRewardAnim) {
        //  已签到七天
        self.reward_full.getChildByName("frame").setVisible(false)
        self.reward_full.getChildByName("reward_prop_2").setVisible(false)
        self.reward_full.getChildByName("reward_prop_1").setVisible(false)
        self.reward_full.getChildByName("frame_marked").setVisible(true)
        self.reward_full.getChildByName("signet_purple1").setVisible(true)
        //  已签到动画
        self.fullMark = self.reward_full.getChildByName("signet_purple1")
        self.fullMarkAnim = cc.CSLoader.createTimeline("cocos/mark_panel_3_signet_purple1.csb");
        self.fullMark.runAction(self.fullMarkAnim)
        self.fullMarkAnim.gotoFrameAndPlay(0, false);
        self.isFullMark = isFullMark
    }
}
/** 
 * 播放补签动画
 * @param info              补签后的信息
 * @param day               目标日期
 * @param isSevenReward     是否领连签奖励
*/
NewMarkPanel.prototype.refreshRemarkWithAnim = function (info, day, isSevenReward = false) {
    var self = this

    var refreshPanel = function () {
        var oldInfo = self.config
        var day = new Date(self.config.cycleStartTime)
        var myday = day.getDay() || 7
        var markedDay = self.getMarkedDay(info.markList);
        let isLastRemark = self.isLastRemark(info)
        for (var i = 0; i < markDay_total; i++) {
            if (((oldInfo.markList[(i+1)] != info.markList[(i+1)]) || (i + self.config.remainDayNum < 7)) && oldInfo.markList[(i+1)] == MarkStatus.UN_MARK) {
                var markInfo = {}
                if (i + self.config.remainDayNum >= 7) {
                    markInfo.needRemark = false
                    if (i + self.config.remainDayNum == 7) {
                        markInfo.isToday = true
                        self.todayAdReward = i
                        continue
                    }
                } else {
                    markInfo.needRemark = true
                }
                markInfo.markedDay = markedDay;
                markInfo.fullMarkReward = info.markRef.mark_reward_full;
                var today = (myday - 1 + i) % markDay_total + 1
                var oldNode = self.markNode[i]
                markInfo.day = i+1
                if (info.markList[(i+1)] == MarkStatus.UN_MARK) {
                    markInfo.mark_reward = info.markRef.mark_reward[today]
                    markInfo.mark_reward_ad = info.markRef.mark_reward_ad[today]
                    
                    markInfo.remarkPrice = info.price
                    markInfo.canVideoRemark = self.canVideoRemark(info.markRef.remark_ad_daily_limit, info.videoTimes, isLastRemark)
                    var markNode = self.createMarkNode(markInfo)
                    markNode.setPosition(oldNode.getPosition())
                    markNode.on(MarkItemEvent.ClickRemark, function (evt) {
                        self.dispatchEvent({
                            name: NewMarkPanelEvent.Remark,
                            day: evt.day,
                            isVideoRemark: evt.isVideoRemark
                        })
                    })
                    self.markNode[i] = markNode
                } else {
                    var markNode = MarkedItem.create(markInfo)
                    markNode.setPosition(oldNode.getPosition())
                }
                cc.eventManager.removeListener(oldNode.listenner)
                oldNode.removeFromParent(true)
                self.addChild(markNode)
                self.markNode[i] = markNode
            }
        }

        //  看广告签到奖励
        var adRewardDay = UserMark.getInstance().getDayPreContinuous()
        if (adRewardDay >= 0) {
            var todayAdRewardLength = self.config.markRef.mark_reward_ad[adRewardDay].length
            self.adRewardNode = []
            for (var i = 0; i < (2 < todayAdRewardLength ? 2 : todayAdRewardLength); i++) {
                var reward = self.adRewardCloud.getChildByName("icon" + (i+1))
                var icon = reward.getChildByName("icon")
                var num = reward.getChildByName("num")
                reward.getChildByName("num").setString(self.config.markRef.mark_reward_ad[adRewardDay][i].num)
                //  奖励图标
                var propMeta = MetaManager.getInstance().getPropMeta(self.config.markRef.mark_reward_ad[adRewardDay][i].id)
                if (propMeta && propMeta.expireTime !== 0) {
                    propIcon = UIItemBuilder.createPropIcon(self.config.markRef.mark_reward_ad[adRewardDay][i].id, (Localhost.time() + propMeta.expireTime))
                } else {
                    propIcon = UIItemBuilder.createPropIcon(self.config.markRef.mark_reward_ad[adRewardDay][i].id)
                }
                propIcon.x = icon.x
                propIcon.y = icon.y
                propIcon.setAnchorPoint(icon.getAnchorPoint())
                propIcon.setName(icon.getName())
                propIcon.setScale(icon.getScale())
                icon.removeFromParent(true)
                reward.addChild(propIcon)
                num.setLocalZOrder(propIcon.getLocalZOrder() + 1)
                 
                if (NewMarkPanel.rewardIsCurrency(self.config.markRef.mark_reward_ad[adRewardDay][i].id)) {
                    reward.getChildByName("num").x = 40
                    reward.getChildByName("num").y = -30.15
                } else {
                    reward.getChildByName("num").x = 48
                    reward.getChildByName("num").y = -35.05
                }
                self.adRewardNode[i] = reward
            }
        } else {
            self.adRewardCloud.setVisible(false)
        }

        //  设置连签状态
        self.refreshFullMarkWithAnim(info)
        
        self.runAction(cc.sequence(cc.delayTime(1)), cc.callFunc(function () {
            if (finishCallback) {
                finishCallback()
            }
        }))
        
        //  刷新签到配置
        self.config = info
        if (self.isFullMark || self.todayMarkRewardAnim) {
            self.markedConfig = null
        }
        self.updateSignDay()
    }

    var startPlayGetRewardRewardAnim = function () {
        self.playGetRemarkRewardAnim(day, refreshPanel, isSevenReward)
    }

    //  先关闭补签面板
    if (self.remarkPanel) {
        self.remarkPanel.onClose(startPlayGetRewardRewardAnim)
    } else {
        startPlayGetRewardRewardAnim()
    }
}

/**
 * 当前是否可用广告补签
 */
NewMarkPanel.prototype.canVideoRemark = function (remark_ad_daily_limit, videoTimes, isLastRemark) {
    var self = this
    if (isLastRemark && AdTagManager.getInstance().isHaveAdLabel()){
        console.log(`[AdTag] 补签广告限制(有标签) isLastRemark=${isLastRemark}`)
        return false
    }
    let [isOpen,limit] = AdTagManager.getInstance().getAdStrategyByAdType(AdTagManager.AdType.ad_repair_mark)
    if (!isOpen){
        console.log(`[AdTag] 补签广告限制 isOpen=${isOpen}`)
        return
    }
    if (remark_ad_daily_limit <= videoTimes || limit <= videoTimes) {
        console.log(`[AdTag] 补签广告限制 isOpen=${isOpen} remark_ad_daily_limit=${remark_ad_daily_limit} limit=${limit} 当前次数${videoTimes}`)
        return false
    } else {
        if (NewMarkPanel.prepareAd) {
            return true
        } else {
            return false
        }
    }
}

/**
 * 创建签到节点
 * @param markInfo 当前节点信息
 */
NewMarkPanel.prototype.createMarkNode = function(markInfo) {
    var self = this

    if (markInfo.needRemark) {
        var markNode = RemarkItem.create(markInfo)
        //  绑定点击事件
        UIButton.create(markNode)
        markNode.on(UIButtonEvent.Click, function () {
            self.dispatchEvent({
                name: NewMarkPanelEvent.ClickRemark,
                markInfo: markInfo
            })
        })
    } else {
        var markNode = MarkItem.create(markInfo)
    }

    return markNode
}

/**
 * 获取已签到天数
 * @param markList  签到信息
 */
NewMarkPanel.prototype.getMarkedDay = function(markList) {
    var self = this

    var result = 0;
    for (var i = 0; i < markList.length; i++) {
        result += markList[i];
    }

    return result;
}

NewMarkPanel.prototype.updateSubmsgDay = function(subAccepted){
    if (subAccepted){
        let dayOfMonth = new Date().getDate()
        cc.UserDefault.getInstance().setStringForKey("mark_submsg_day", dayOfMonth)
    }
}

NewMarkPanel.prototype.trySubscribeMsg = function(){
    var self = this

    if (self.subMsg){
        let userInstance = cc.UserDefault.getInstance()
        userInstance.setStringForKey("sign_msg_selected", self.subMsg.getSelected())
        
        let curDay = new Date().getDate()
        let lastSubMsgDay = userInstance.getStringForKey("mark_submsg_day")
        console.log("@@@@mark submsg curday:", curDay, " lastDay:",lastSubMsgDay)
        let isShowTip = !self.oldSelectSign && self.subMsg.getSelected()
        self.subMsg.trySubscribeMsg(curDay != lastSubMsgDay, handler(self, self.updateSubmsgDay),isShowTip)
    }
    
}

NewMarkPanel.prototype.initSubscribeMessage = function(canMark){
    var self = this

    var subKey = "";
    if (window.mini && mini.getPlatform() == MiniPlatform.wechatGame) {
        subKey = "uQ6E7ML6iyiuX5pwN1JKdsvYIOJeHzwYHYMmuJ-P_MM";
    }else if (window.mini && mini.getPlatform() == MiniPlatform.qqlightGame) {
        subKey = "092652a52796c7fa6b89f577a2804ed5";
    }

    var moduleId = UISubscribeMessage.getModuleId(subKey)
    let subCfg = MetaManager.getInstance().getSubscribeCfg()
    console.log("@@@@get sub cfg:", subCfg, " moduleId:", moduleId)
    let userInstance = cc.UserDefault.getInstance()
    let dayOfMonth = new Date().getDate()
    let preSaveDay = userInstance.getStringForKey("submsg_data")
    let firstShowSubMsg = true
    userInstance.setStringForKey("submsg_data", dayOfMonth)
    if (preSaveDay == dayOfMonth){
        firstShowSubMsg =  false
    }
    let selectSign = true
    if (!firstShowSubMsg){
        selectSign = userInstance.getStringForKey("sign_msg_selected")
        if (string.isEmpty(selectSign) || selectSign == "false"){
            selectSign = false
        }
    }
    self.oldSelectSign = selectSign
    console.log("@@@@sign firstshow:", firstShowSubMsg, " lastSelect:", selectSign)
    
    if (!subCfg[moduleId] || subCfg[moduleId] <= 0)
        return;
        
    if (self.subMsg != null)
        return;
    if (isWechatGameEnv() && mini.supportSubscribeMessage()){
        UISubscribeMessage.preload().then(
            ()=>{
                console.log("@@@@new mark panel subscribe msg success")
                self.subMsg = UISubscribeMsg.create(
                    subKey, 
                    getText("subscription_mark_text"),
                    cc.c3b(236,255,255),
                    selectSign,
                    false,
                    true,
                    false,
                    getText("subscription_mark_success"),
                    getText("subscription_mark_fail"),
                    )
                let msgW = self.subMsg.getWidth()
                let size = self.getContentSize()
                let offsetY = 0
                if (!canMark){
                    offsetY = 200
                }
                self.subMsg.setPosition((size.width+50 - msgW)*0.5, -size.height+offsetY)
                self.addChild(self.subMsg)
            }).catch(()=>{console.log("@@@@new mark panel subscribe msg error")})
    }
}
/**
 * 签到状态，值需要与后端协商，具体详见签到系统优化文档（2019-07-29）
 */
MarkStatus = table.const({
    UN_MARK: 0,
    MARKED: 1
})
module.exports = {
    NewMarkPanel: NewMarkPanel,
    NewMarkPanelEvent: NewMarkPanelEvent
}
